import validate from "/app/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.5.1_@types+node@24.2.0_db0@0.3.2_encoding@0.1.13_eslint@9_efe516b856ef27ee3dd6749ee5c70e29/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect_45global from "/app/app/platform/middleware/01.redirect.global.ts";
import _02_45auth_45global from "/app/app/platform/middleware/02.auth.global.ts";
import _03_45store_45global from "/app/app/platform/middleware/03.store.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.5.1_@types+node@24.2.0_db0@0.3.2_encoding@0.1.13_eslint@9_efe516b856ef27ee3dd6749ee5c70e29/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45redirect_45global,
  _02_45auth_45global,
  _03_45store_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}